import { Record } from 'immutable';

const TradeInRecord = Record({
    amountSummary: {
        tradeIn: 0,
        lien: 0,
    },
    tradeInVehicles: [],
});

class TradeIn extends TradeInRecord {}

export default TradeIn;
